import { Link } from "react-router-dom";
import NewsCard from "@/components/feature/NewsCard";
import { newsList } from "@/mocks/news";

export default function LatestNews() {
  const items = newsList.slice(0, 6);
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-leaf-line text-xl text-primary-600" />
              <span className="text-sm font-medium text-primary-700">最新更新</span>
            </div>
            <h2 className="mt-2 font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
              最新动漫资讯
            </h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600"
          >
            查看全部资讯
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {items.map((item) => (
            <NewsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}